var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _rect6, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _g2, _path12, _path13, _path14, _path15, _path16, _polygon, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _polygon2, _path24, _path25, _path26, _path27, _path28, _polygon3, _path29, _path30, _rect7, _rect8, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _polygon4, _path40, _rect9, _rect10, _path41, _path42, _path43, _path44, _path45, _circle, _circle2, _path46, _polygon5, _path47, _path48, _path49, _path50, _path51, _path52, _polygon6, _path53, _path54;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1637.95 1563.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#dee5f8;stroke-miterlimit:10;}.cls-1{stroke-width:5px;}.cls-2{stroke-width:3.75px;}.cls-3{fill:#fbc343;}.cls-4,.cls-5,.cls-7{fill:#6f3428;}.cls-5,.cls-8{opacity:0.3;}.cls-6{fill:#fff;opacity:0.6;}.cls-7{opacity:0.1;}.cls-16,.cls-9{fill:#102048;}.cls-10{fill:#e28b6d;}.cls-11{fill:#f9b384;}.cls-12{fill:#fc8879;}.cls-13{fill:#708cd5;}.cls-14{fill:#1f3c88;}.cls-15{fill:#acbfee;}.cls-16{opacity:0.15;}.cls-17{fill:#396caa;opacity:0.2;}.cls-18{fill:#dee5f8;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 390.7,
    y: 1025.88,
    width: 241.38,
    height: 40.75,
    rx: 9.92
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 651.56,
    y: 1025.46,
    width: 115,
    height: 40.75,
    rx: 12.42
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 596.48,
    y: 475.08,
    width: 115,
    height: 40.75,
    rx: 12.42
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 732.52,
    y: 475.08,
    width: 115,
    height: 40.75,
    rx: 12.42
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1077.99,
    y: 841.67,
    width: 115,
    height: 40.75,
    rx: 12.42
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1784.57,533.07v11.74c3.94,0,8.38,1.07,11.34,9,3.26,8.72,3.41,22.47.43,38.74-3.36,18.31-10.56,39.43-20.84,61.09-21.2,44.64-54.14,89.21-94,127.51l-5.91-130.44,34.79-48.18h29.34A20.26,20.26,0,0,0,1760,582.3V554.83a9.4,9.4,0,0,1,3.15-2.52c10.66-6.19,17.55-7.5,21.45-7.5V533.07m0,0c-7.51,0-16.64,2.87-27.34,9.09-4.91,2.85-9,6.87-9,12.54v27.6a8.5,8.5,0,0,1-8.5,8.5h-35.34l-40.71,56.37,7.23,159.56c136.73-118.65,168.88-273.66,113.65-273.66Z",
    transform: "translate(-172.27 -199.08)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1363.77,533.07v11.74c3.89,0,10.78,1.31,21.44,7.5a9.27,9.27,0,0,1,3.15,2.52V582.3a20.26,20.26,0,0,0,20.24,20.24h29.34l34.79,48.18-5.91,130.44c-39.85-38.3-72.79-82.87-94-127.51-10.28-21.66-17.48-42.78-20.84-61.09-3-16.27-2.83-30,.43-38.74,3-7.94,7.4-9,11.35-9V533.07m0,0c-55.23,0-23.08,155,113.65,273.66l7.23-159.56-40.71-56.37H1408.6a8.5,8.5,0,0,1-8.5-8.5V554.7c0-5.67-4.08-9.69-9-12.54-10.7-6.22-19.83-9.09-27.34-9.09Z",
    transform: "translate(-172.27 -199.08)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1286.82,
    y: 890.81,
    width: 230.16,
    height: 119.44
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1353.56,820.32h96.67a31.51,31.51,0,0,1,31.51,31.51v39a0,0,0,0,1,0,0H1322a0,0,0,0,1,0,0v-39A31.51,31.51,0,0,1,1353.56,820.32Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1371.8,776.44H1432a19.62,19.62,0,0,1,19.62,19.62v24.26a0,0,0,0,1,0,0h-99.42a0,0,0,0,1,0,0V796.06A19.62,19.62,0,0,1,1371.8,776.44Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1601.9,963.25l3.1,12.27h-61.65l3.07-12.27a99,99,0,0,0,0-49L1543.35,902H1605l-3.1,12.28a100.35,100.35,0,0,0-2.7,16.14A99,99,0,0,0,1601.9,963.25Z",
    transform: "translate(-172.27 -199.08)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1605,902l-3.1,12.28a100.35,100.35,0,0,0-2.7,16.14c-3.37-22.45-55.85-28.42-55.85-28.42Z",
    transform: "translate(-172.27 -199.08)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1623.88,858.07v24.25a19.85,19.85,0,0,1-.85,5.75A19.64,19.64,0,0,1,1604.25,902h-60.17a19.63,19.63,0,0,1-19.63-19.63V858.07Z",
    transform: "translate(-172.27 -199.08)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1623.88,858.07v24.25a19.85,19.85,0,0,1-.85,5.75c-26.55-24.4-94-25.12-98.58-25.14v-4.86Z",
    transform: "translate(-172.27 -199.08)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1728.58,565l-28.5,124.45L1668.45,827.6a45.46,45.46,0,0,1-44.32,35.33H1524.2a45.51,45.51,0,0,1-44.28-35.13c0-.08,0-.12,0-.2L1419.75,565a9.73,9.73,0,0,1,7.58-11.75,750.46,750.46,0,0,1,293.67,0A9.74,9.74,0,0,1,1728.58,565Z",
    transform: "translate(-172.27 -199.08)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1508.66,640c2.19,17.93-1.39,33.12-8,33.93s-13.73-13.08-15.92-31,1.4-33.12,8-33.93S1506.47,622.07,1508.66,640Z",
    transform: "translate(-172.27 -199.08)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1700.08,689.47,1668.45,827.6a45.46,45.46,0,0,1-44.32,35.33H1524.2a45.51,45.51,0,0,1-44.28-35.13C1589.75,820.87,1662.8,751.25,1700.08,689.47Z",
    transform: "translate(-172.27 -199.08)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1543.35,975.52a110.92,110.92,0,0,1,15.33-2.55c5.14-.56,10.31-.8,15.49-.89,10.33,0,20.78.68,30.83,3.44-5.21.15-10.32.14-15.45.17l-15.35.14C1564,975.88,1553.73,976,1543.35,975.52Z",
    transform: "translate(-172.27 -199.08)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1524.45,1019.4a424.22,424.22,0,0,1,49.71-3.37c8.3-.09,16.62,0,24.92.46a156.83,156.83,0,0,1,24.8,2.91c-8.32-.27-16.58-.06-24.85,0l-24.83.37C1557.65,1019.93,1541.09,1020.11,1524.45,1019.4Z",
    transform: "translate(-172.27 -199.08)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1529.48,366.64l10.29,74.08a4,4,0,0,1-7.33,2.52l-37.39-64.77a7.28,7.28,0,0,1,4-10.53l20.88-7.17A7.28,7.28,0,0,1,1529.48,366.64Z",
    transform: "translate(-172.27 -199.08)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1632.88,322.29,1592.4,449.46c-2.34,7.37-13.13,6.12-13.72-1.59l-10.32-133.06a13,13,0,0,1,14.47-13.9l39.13,4.54A13,13,0,0,1,1632.88,322.29Z",
    transform: "translate(-172.27 -199.08)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1680.14,400.2l-48.29,46.05a3.52,3.52,0,0,1-5.64-4l27.43-60.83a6.5,6.5,0,0,1,9.69-2.62l16.07,11.39A6.49,6.49,0,0,1,1680.14,400.2Z",
    transform: "translate(-172.27 -199.08)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M594,776.34c21.67,13.5,44.67-4,47.19-18.8,3.75-22.08-16.36-47.5-47.19-28.64,0,0-26.73-31.25-52.69-.31,0,0-44.29,22.29-19.71,61s55.43-14,55.43-14Z",
    transform: "translate(-172.27 -199.08)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M609.72,786c11.87,15.94,17.1,22.22,15.42,27.2s-13.55,5.39-13.55,5.39Z",
    transform: "translate(-172.27 -199.08)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "419.01 636.18 412.21 653.18 385.91 718.95 343.49 668.73 383.54 609.5 407.44 627.48 419.01 636.18"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M591.28,835.26l-6.8,17a210.73,210.73,0,0,1-22-26.45l17.2.75Z",
    transform: "translate(-172.27 -199.08)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M615.91,826.74c-.38,9-2.15,15.92-6.53,19-12.57,8.9-58.75-29-58.75-29l-3.15-53.42,64.93,4.62c.12,8.58,1.05,18.23,1.92,27.75C615.33,806.79,616.31,817.76,615.91,826.74Z",
    transform: "translate(-172.27 -199.08)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M553.51,789.52c15.89,3,20-14.58,20-14.58,17-10.42,31.07,13.65,46.37,4.68l2.36-30.72-67.3-3.44-24.26,15.63,6.87,18.75Z",
    transform: "translate(-172.27 -199.08)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M563.46,789.86c-8.55-9.71-22.36-5.55-23.68,4.87s7.29,28,21.26,17.8Z",
    transform: "translate(-172.27 -199.08)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M615.91,826.74a15.15,15.15,0,0,1-4.3.6,16,16,0,1,1,0-31.93,14.34,14.34,0,0,1,2.72.25C615.33,806.79,616.31,817.76,615.91,826.74Z",
    transform: "translate(-172.27 -199.08)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M557.63,796.78a7.5,7.5,0,0,0-2.38-2.84,9.34,9.34,0,0,0-3.27-1.68,4.86,4.86,0,0,0-3.35.1,6.36,6.36,0,0,0-2.64,2.46l-.68-.28a5.76,5.76,0,0,1,2.57-3.64,6,6,0,0,1,4.6-.43,9.27,9.27,0,0,1,3.82,2.28,6.4,6.4,0,0,1,2.05,3.89Z",
    transform: "translate(-172.27 -199.08)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M619.85,958.05c14-16.3,15.42-39.58,20.74-44.36C650.48,904.8,646,932,646,932s6.44-18.31,21.91-22.45c10.13-2.72,11.94,6.71,11.06,14.59-1.46,13.09-5.76,28.07-16.34,36.77-4.51,3.7-10.27,6.52-13.51,11.52a34.26,34.26,0,0,0-4.34,9.34Z",
    transform: "translate(-172.27 -199.08)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "445.36 759.5 451.88 750.72 478.39 774.3 470.98 785 445.36 759.5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M533.81,1045.05l84.36-94,31.32,30.74c-22.4,50.93-52.07,83.61-99.64,108.61Z",
    transform: "translate(-172.27 -199.08)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M653.85,931.22a9.68,9.68,0,0,1,4.77.52,21.92,21.92,0,0,1,4.23,1.94,24.64,24.64,0,0,1,3.76,2.67,10,10,0,0,1,3,3.78l-.91.34a30.44,30.44,0,0,0-3.43-2.36c-1.23-.78-2.47-1.55-3.72-2.29s-2.5-1.45-3.76-2.13a16.29,16.29,0,0,0-3.92-1.49Z",
    transform: "translate(-172.27 -199.08)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M645.77,936.93a10,10,0,0,1,4.62,3.29,8.12,8.12,0,0,1,1.42,5.77,11.64,11.64,0,0,1-2.14,5.35,8.65,8.65,0,0,1-4.49,3.53l-.31-.93a11.79,11.79,0,0,0,2.94-3.77,13.12,13.12,0,0,0,1.53-4.47,7.34,7.34,0,0,0-.73-4.35,13.55,13.55,0,0,0-3.29-3.56Z",
    transform: "translate(-172.27 -199.08)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M353.46,1045.05l-89.85-24.49h0a12.5,12.5,0,0,1,15.35-8.77l65.73,17.91a12.51,12.51,0,0,1,8.77,15.35Z",
    transform: "translate(-172.27 -199.08)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M318.77,1536.08s18.37,39.09,71.22,26.52l-25.49-33.81Z",
    transform: "translate(-172.27 -199.08)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "164.43 1332.19 145.62 1374.51 166.15 1406.88 191.55 1386.22 202.78 1339.65 164.43 1332.19"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M317.89,1573.59l45.93,11.71,26.05,64.47a7.11,7.11,0,0,1-9.69,9.07l-81.49-39.4a12.06,12.06,0,0,1-5.73-15.85l.72-1.58a67.87,67.87,0,0,1,24.21-28.42Z",
    transform: "translate(-172.27 -199.08)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M317.89,1573.59l45.93,11.71,26.05,64.47a7.11,7.11,0,0,1-9.69,9.07l-81.49-39.4a12.06,12.06,0,0,1-5.73-15.85l.72-1.58a67.87,67.87,0,0,1,24.21-28.42Z",
    transform: "translate(-172.27 -199.08)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 360.54,
    y: 1609.35,
    width: 13.05,
    height: 2.5,
    transform: "translate(-912.75 185.91) rotate(-29.26)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 366.23,
    y: 1623.62,
    width: 13.05,
    height: 2.5,
    transform: "translate(-920.21 191.61) rotate(-29.32)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M379.93,1099.79c-8.88,20.92-20.94,53.07-.73,91.7a74.21,74.21,0,0,1,7,51l-67.45,293.58L390,1562.6l145.74-425.13Z",
    transform: "translate(-172.27 -199.08)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M570.47,888.38c14.4,41.31,14.8,111.85-12.54,186.28l-42.18,12,17-137.86Z",
    transform: "translate(-172.27 -199.08)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M524.17,852.9l11.56-25.56s32.73,22.81,49.92,50l-20,37.72Z",
    transform: "translate(-172.27 -199.08)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M532.68,1069.21c-112-3.6-170.7,59.2-170.27,56.75,18-61.15,35-106.87,50.2-141,27.55-61.92,49.2-85.82,60.45-94.82,5.5-4.43,8.52-5.28,8.52-5.28l51-42.72a55.78,55.78,0,0,1,12.42,9.1c14.38,13.5,22.6,32.15,24.55,51.75C577.23,979.71,532.68,1069.21,532.68,1069.21Z",
    transform: "translate(-172.27 -199.08)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M500.33,892.54c-16.35,8.68-44.75,54-87.72,92.42,27.55-61.92,49.2-85.82,60.45-94.82Z",
    transform: "translate(-172.27 -199.08)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M316.11,987.72l-18,25.61S295.84,1023.8,291,1028c0,0,2.16,10.73,10.59,14.5,9.64,4.3,21.52,4.06,29.22-6.93s8.71-43.61,8.71-43.61Z",
    transform: "translate(-172.27 -199.08)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M303.67,993c0,1.67-3.34,10.83-3.34,10.83l39.21,5.42V991.92Z",
    transform: "translate(-172.27 -199.08)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M532.62,842.13S458,830.94,397.34,862.35a99.14,99.14,0,0,0-23.27,16.89c-29.27,28.37-55.42,56.3-75.21,115.6l46.62,7.62,47-69.45a28.51,28.51,0,0,1,17.21-11.73c24.88-5.68,84.54-19.64,93.89-25.09Z",
    transform: "translate(-172.27 -199.08)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M598,1288.55s28.07,37.4,74.56,18.61l-31-33Z",
    transform: "translate(-172.27 -199.08)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "442.94 1079.65 424.13 1121.96 444.67 1154.34 470.06 1133.68 481.29 1087.11 442.94 1079.65"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M596.4,1321l45.93,11.72,26.06,64.47a7.12,7.12,0,0,1-9.7,9.07l-81.49-39.4a12.07,12.07,0,0,1-5.73-15.86l.72-1.58A68.07,68.07,0,0,1,596.4,1321Z",
    transform: "translate(-172.27 -199.08)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 638.88,
    y: 1355.65,
    width: 13.05,
    height: 2.5,
    transform: "translate(-753.21 289.6) rotate(-29.26)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 644.56,
    y: 1369.93,
    width: 13.05,
    height: 2.5,
    transform: "translate(-760.32 295.41) rotate(-29.32)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M379.93,1099.79c15.32-10.6,113-36.2,175-34.33,68.91,2.08,124.21,9.91,146.69,60.37s-29,181.33-29,181.33L598,1288.55l18-121.33s-94.42,11.91-139.42,12.41Z",
    transform: "translate(-172.27 -199.08)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M535.72,1176.41c-7.68,0-15.06,2-22.65,3.52a109.28,109.28,0,0,1-23.18,2.08,205.29,205.29,0,0,1-23.13-1.9c-3.82-.55-7.62-1.22-11.43-1.83-3.78-.78-7.57-1.51-11.33-2.34l.17-1c3.82.48,7.62,1,11.43,1.57s7.62,1,11.43,1.39c7.62.83,15.26,1.46,22.89,1.6a118.9,118.9,0,0,0,22.77-1.69c3.78-.61,7.55-1.39,11.4-1.93a72.07,72.07,0,0,1,11.65-.49Z",
    transform: "translate(-172.27 -199.08)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M393.33,1103.84l-23.67,86.87-2.78,10.13a20.12,20.12,0,0,1-24.7,14.1l-155.07-42.28A20.11,20.11,0,0,1,173,1148l15.6-57.17,10.85-39.8a20.11,20.11,0,0,1,24.68-14.13l155.1,42.28A20.13,20.13,0,0,1,393.33,1103.84Z",
    transform: "translate(-172.27 -199.08)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M249.81,1071.23l13.76-50.47a12.51,12.51,0,0,1,15.35-8.78h0l-17.05,62.54Z",
    transform: "translate(-172.27 -199.08)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M328.46,1089.27l16.24-59.57h0a12.5,12.5,0,0,1,8.77,15.35l-13,47.51Z",
    transform: "translate(-172.27 -199.08)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 82.68,
    cy: 877.05,
    r: 10.76
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 161.49,
    cy: 894.51,
    r: 10.76
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M369.66,1190.71l-2.78,10.13a20.12,20.12,0,0,1-24.7,14.1l-155.07-42.28A20.11,20.11,0,0,1,173,1148l20.71-75.9C188.46,1143.85,300.33,1190.46,369.66,1190.71Z",
    transform: "translate(-172.27 -199.08)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "1548.36 1013.55 1548.36 1119.7 383.7 1563.27 110.15 1563.27 110.15 1461.17 381.25 1461.17 381.55 1404.92 381.88 1348.52 654.2 1348.52 654.2 1235.89 925.3 1235.89 925.3 1126.09 1196.43 1126.09 1196.43 1013.44 1548.36 1013.55"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1094.64,1437.9H827.26a5.46,5.46,0,0,1-5.44-5.45h0a5.46,5.46,0,0,1,5.44-5.44h267.38a5.46,5.46,0,0,1,5.44,5.44h0A5.46,5.46,0,0,1,1094.64,1437.9Z",
    transform: "translate(-172.27 -199.08)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1366.31,1329.56H1098.93a5.46,5.46,0,0,1-5.45-5.44h0a5.46,5.46,0,0,1,5.45-5.44h267.38a5.46,5.46,0,0,1,5.44,5.44h0A5.46,5.46,0,0,1,1366.31,1329.56Z",
    transform: "translate(-172.27 -199.08)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1720.8,1215.47H1368.2a5.46,5.46,0,0,1-5.44-5.44h0a5.46,5.46,0,0,1,5.44-5.45h352.6a5.46,5.46,0,0,1,5.44,5.45h0A5.46,5.46,0,0,1,1720.8,1215.47Z",
    transform: "translate(-172.27 -199.08)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M823.31,1549.89H555.93a5.46,5.46,0,0,1-5.44-5.45h0a5.46,5.46,0,0,1,5.44-5.44H823.31a5.46,5.46,0,0,1,5.44,5.44h0A5.46,5.46,0,0,1,823.31,1549.89Z",
    transform: "translate(-172.27 -199.08)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M550.94,1662.52H283.56a5.45,5.45,0,0,1-5.44-5.44h0a5.45,5.45,0,0,1,5.44-5.44H550.94a5.45,5.45,0,0,1,5.44,5.44h0A5.46,5.46,0,0,1,550.94,1662.52Z",
    transform: "translate(-172.27 -199.08)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M849.5,1064l-1.49-16.8,26.8-2.37a343.59,343.59,0,0,0,298.24-239.61l34.29-108.76,16.09,5.07-34.29,108.76a360.41,360.41,0,0,1-312.85,251.34Z",
    transform: "translate(-172.27 -199.08)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1043.55 600.51 1036.22 520.45 981.81 583.51 969.03 572.49 1049.4 479.36 1060.35 598.97 1043.55 600.51"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M591.89,480.36a13.32,13.32,0,0,1-3.11,8.25H283.07a20,20,0,0,1-1.79-8.25c0-15.34,17.82-27.77,39.8-27.77a53.54,53.54,0,0,1,19.22,3.46c3-21.78,32.85-38.89,69.23-38.89,37.93,0,68.75,18.57,69.49,41.64,11.89-3.87,27.1-6.21,43.64-6.21C560.9,452.59,591.89,465,591.89,480.36Z",
    transform: "translate(-172.27 -199.08)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1124.71,274.73a16,16,0,0,1-3.73,9.87H755.1a23.92,23.92,0,0,1-2.15-9.87c0-18.36,21.33-33.24,47.65-33.24a63.9,63.9,0,0,1,23,4.14c3.59-26.07,39.32-46.55,82.86-46.55,45.39,0,82.28,22.24,83.16,49.85,14.24-4.64,32.44-7.44,52.24-7.44C1087.62,241.49,1124.71,256.37,1124.71,274.73Z",
    transform: "translate(-172.27 -199.08)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInB);
export default __webpack_public_path__ + "static/media/in-b.a9636d3af094d6f505427ab1a1fe283d.svg";
export { ForwardRef as ReactComponent };